export const UPDATE_CURRENT_TRANSACTION = `transactions/UPDATE_CURRENT_TRANSACTION`
export const TRANSACTION_UPDATED = `transactions/TRANSACTION_UPDATED`
export const UPDATE_PAYMENT_STATUS = `transactions/UPDATE_PAYMENT_STATUS`
export const UPDATE_ERROR_MESSAGE = `transactions/UPDATE_ERROR_MESSAGE`
